import { SharedUtilString } from '@luggagehero/shared/util';

/**
 * @deprecated Use `SharedUtilString` from `@luggagehero/shared/util` instead
 */
export class StringUtil extends SharedUtilString {}
